import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import type { CommunityEssentialModel } from '@/models'
import { resetQueries } from '@/utils/api/reset-queries'

import { GET_ALL_FOLDERS_BASE_QUERY_KEY } from './get-all-folders'
import { GET_FOLDER_CONTENT_BASE_QUERY_KEY } from './get-folder-content'

export interface UpdateCommunityEssentialRequest {
  id: number
  buildingId: number
  name?: string
  value?: string
  icon?: string
  type?: string
  position?: number
  file?: File
  folderId?: number | null
}

export const updateCommunityEssential = async (data: UpdateCommunityEssentialRequest) => {
  const { id, ...rest } = data
  const response = await authAPI.put<CommunityEssentialModel>(`/building-essential/${id}`, rest)
  return response.data
}

export const useUpdateCommunityEssential = () => {
  return useMutation({
    mutationFn: updateCommunityEssential,
    onSuccess: () =>
      resetQueries([GET_FOLDER_CONTENT_BASE_QUERY_KEY], [GET_ALL_FOLDERS_BASE_QUERY_KEY]),
  })
}
